import { fetchAPI } from 'api';
import { DestinationResponse } from 'pages/Wallet/types';
import { MoneyScaled } from 'types';

export interface SendPreviewResponseBase {
  id: string;
  destination: DestinationResponse;
  amount: MoneyScaled;
}

export type CreateSendPreviewResponse = SendPreviewResponseBase & {
  destinationAddress: string;
  walletId: string;
  createdAt: Date;
  amountReference: MoneyScaled;
  serviceFee: MoneyScaled;
  totalReference: MoneyScaled;
  estimatedNetworkFee: MoneyScaled;
  estimatedTotal: MoneyScaled;
};

export const createSendPreview = async (receiveOrderPreviewId: string) => {
  return await fetchAPI<CreateSendPreviewResponse>('send/previews', {
    method: 'POST',
    body: {
      receiveOrderPreviewId,
    },
  });
};

export type SendOrderPreviewResponse = SendPreviewResponseBase & {
  status: string;
};

export const sendOrder = async (previewId: string) => {
  return await fetchAPI<SendOrderPreviewResponse>('send/orders', {
    method: 'POST',
    body: {
      previewId,
    },
  });
};
